/**
 * The Google MapType Control style constants
 *
 * @see https://developers.google.com/maps/documentation/javascript/controls
 */
module.exports = {
  DEFAULT: 0,
  HORIZONTAL_BAR: 1,
  DROPDOWN_MENU: 2,
  INSET: 3,
  INSET_LARGE: 4
};
